<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <base-input
                type="text"
                col="3"
                :placeholder="$t('PLACEHOLDERS.user_name')"
                v-model="filterOptions.user_name"
              />
              <base-input
                type="text"
                col="3"
                :placeholder="$t('PLACEHOLDERS.mobile')"
                v-model="filterOptions.mobile"
              />
              <!-- Start:: Start Date Input -->
              <base-picker-input
                col="3"
                type="date"
                :placeholder="$t('PLACEHOLDERS.startDate')"
                v-model.trim="filterOptions.from_date"
              />
              <!-- End:: Start Date Input -->

              <!-- Start:: End Date Input -->
              <base-picker-input
                col="3"
                type="date"
                :placeholder="$t('PLACEHOLDERS.endDate')"
                v-model.trim="filterOptions.to_date"
              />
              <!-- End:: End Date Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.financialpack") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>

        <div class="title_route_wrapper">
          <div class="excel" @click="downloadFile('excel')">
            {{ $t("BUTTONS.downloadExcel") }}
          </div>

          <base-button
            class="mt-0 pdf_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadPdf')"
            @fireClick="downloadFile('pdf')"
            :disabled="pdfDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-pdf"></i>
            </template>
          </base-button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        hide-default-footer
        @click:row="navigateToUserSubscriptions"
      >
        <!-- :items-per-page="paginations.items_per_page" -->
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <template v-slot:[`item.id`]="{ item, index }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.id">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.id }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.count_use`]="{ item }">
          <router-link
            :to="{
              path: `/users/all`,
              query: {
                page: 1,
                package_id: item.package_id,
              },
            }"
          >
            {{ item.count_use }}
          </router-link>
        </template>

        <template v-slot:[`item.start_date`]="{ item }">
          <span>{{ formatDisplayDate(item.start_date) }}</span>
        </template>

        <template v-slot:[`item.end_date`]="{ item }">
          <span>{{ formatDisplayDate(item.end_date) }}</span>
        </template>

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <!--  v-if="permissions.show" -->
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->
      </v-data-table>
      <div class="table_content">
        <div class="table_title_wrapper">
          <div class="title_text_wrapper">
            <!-- <h5>{{ $t("PLACEHOLDERS.Overall_statistics") }}</h5> -->
          </div>
        </div>
        <v-simple-table class="stat-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_paid_amount") }}
                </th>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.totalTaxValue") }}
                </th>
                <th class="text-center">
                  {{ $t("PLACEHOLDERS.total_platform_profit") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template>
                <tr class="text-center all-stat">
                  <td>{{ total_profit }}</td>
                  <td>{{ total_tax }}</td>
                  <td>{{ totalProfitWithTax }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!--  =========== End:: Data Table =========== -->
      <!-- ==== Start:: Overall_statistics Addresses ==== -->

      <!-- ==== End:: Overall_statistics Addresses ==== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->

    <!-- Start:: Generate PDF Template Content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="$t('PLACEHOLDERS.financialpack')"
      :pdf-quality="2"
      pdf-format="a4"
      :manual-pagination="false"
      :paginate-elements-by-height="1400"
      pdf-content-width="100%"
      @progress="bdfDownloadBtnIsLoading = true"
      @hasGenerated="$message.success($t('MESSAGES.generatedSuccessfully'))"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="pdf_file_content">
          <h3 class="file_title">{{ $t("PLACEHOLDERS.financialpack") }}</h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in tableHeaders"
                    :key="header.value"
                  >
                    <span v-if="index !== 5">{{ header.text }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in tableRows" :key="row.id">
                  <td>{{ row.id ? row.id : "-" }}</td>
                  <td>{{ row.package_name ? row.package_name : "-" }}</td>
                  <td>{{ row.perioud ? row.perioud : "-" }}</td>
                  <td>
                    {{ row.sub_total ? row.sub_total : "-" }}
                  </td>
                  <td>{{ row.total ? row.total : "-" }}</td>
                  <td>{{ row.tax ? row.tax : "-" }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </section>
    </vue-html2pdf>
    <!-- End:: Generate PDF Template Content -->
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";

export default {
  name: "AllFinancialReports",

  components: {
    VueHtml2pdf,
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      statistic: {
        count: null,
        providerRevenu: null,
        appRevenu: null,
        totalVat: null,
      },

      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      pdfDownloadBtnIsLoading: false,
      excelDownloadBtnIsLoading: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        package_name: null,
        mobile: null,
        from_date: null,
        to_date: null,
      },
      allproviders: [],
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.user"),
          value: "username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.mobile"),
          value: "mobile",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.startDate"),
          value: "start_date",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.endDate"),
          value: "end_date",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_subscriptions"),
          value: "total",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_app_profit"),
          value: "total_app_profit",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.total_tax_value"),
          value: "total_vat",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      users: [],
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogPdf: false,
      itemToPdf: null,
      dialogExcel: false,
      itemToExcel: null,
      // End:: Dialogs Control Data

      // Start:: Page Permissions
      permissions: null,
      // Start:: Page Permissions
      total_profit: null,
      total_tax: null,
      pdf: null,
      excel_report: null,
      totalProfitWithTax: null,
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    formatDisplayDate(value) {
      if (!value) return this.$t("TABLES.noData");
      const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return value;
      return `${match[3]}/${match[2]}/${match[1]}`;
    },

    // Start:: Handel Filter
    async submitFilterForm() {
      // if (this.$route.query.page !== "1") {
      // await this.$router.push({
      //   path: "/financialpack/all",
      //   // query: { page: 1 },
      // });
      // }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.user_name = null;
      this.filterOptions.mobile = null;
      this.filterOptions.from_date = null;
      this.filterOptions.to_date = null;
      // if (this.$route.query.page !== "1") {
      // await this.$router.push({
      //   path: "/financialpack/all",
      //   // query: { page: 1 },
      // });
      // }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async getUsers() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `packages?page=0&limit=0`,
        });
        this.users = res.data.data?.map((ele) => ({
          id: ele.id,
          name: ele.name,
          value: ele.name,
        }));
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "reports/subscriptions?page=1",
          params: {
            page: this.paginations.current_page,
            limit: 10,
            username: this.filterOptions.user_name,
            mobile: this.filterOptions.mobile,
            from: this.filterOptions.from_date,
            to: this.filterOptions.to_date,
          },
        });
        this.loading = false;

        // Extract the report data properly
        const reportData = res.data.data[0].report;

        // Check if report has data property (paginated response)
        this.tableRows = Array.isArray(reportData)
          ? reportData
          : reportData.data || [];

        this.total_profit = res.data.data[0].totals.all_pages.total;
        this.totalProfitWithTax =
          res.data.data[0].totals.all_pages.total_app_profit;
        this.total_tax = res.data.data[0].totals.all_pages.total_vat;

        if (reportData.last_page) {
          this.paginations.last_page = reportData.last_page;
          this.paginations.items_per_page = reportData.per_page;
        }
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Handling Download Files
    async downloadFile(type) {
      const url =
        type === "pdf"
          ? "reports/subscriptions/generate-pdf"
          : "reports/subscriptions/generate-excel";
      try {
        const response = await this.$axios.get(url);
        if (response.data && response.data.data && response.data.data.data) {
          window.open(response.data.data.data, "_blank");
        } else {
          this.$message.error("Download link not found");
        }
      } catch (error) {
        console.log(error);
        this.$message.error("Download failed");
      }
    },
    // End:: Handling Download Files

    // Start:: Navigation
    navigateToUserSubscriptions(item) {
      this.$router.push({
        path: `/financial-packages/subscriptions/${item.user_id}`,
      });
    },
    // End:: Navigation

    // ==================== Start:: Crud ====================
    // ===== Start:: Show
    showItem(item) {
      // this.$router.push({ path: `/orders/show/${item.provider_applicant.id}` });
      this.$router.push({
        path: `/orders/all`,
        query: { provider: item.provider_applicant },
      });
    },
    // ===== End:: Show

    // ==================== End:: Crud ====================
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    this.getUsers();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.ex-btn-s {
  color: black !important;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline !important;
}

.all-stat {
  background: var(--main_theme_clr);
}

.all-stat td {
  color: white;
  font-size: 21px !important;
  font-weight: 800;
}

.show_all_content_wrapper
  .v-data-table
  .v-data-table__wrapper
  table
  tbody
  tr:hover {
  background: var(--main_theme_clr) !important;
  text-align: center;
}

table,
tbody,
tr,
td {
  text-align: center !important;
}

.excel {
  background: darkgreen;
  padding: 7px 10px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
